// extracted by mini-css-extract-plugin
export default {"closeButton":"collaboration-components_closeButton__ht4AB"};